import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var chart_bar_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
  Path,
  {
    fillRule: "evenodd",
    d: "M11.25 5h1.5v15h-1.5V5zM6 10h1.5v10H6V10zm12 4h-1.5v6H18v-6z",
    clipRule: "evenodd"
  }
) });
export {
  chart_bar_default as default
};
//# sourceMappingURL=chart-bar.js.map
